export const FOCUSABLE = `
  a[href]:not([tabindex="-1"]),
  button:enabled:not([tabindex="-1"]),
  input:enabled:not([tabindex="-1"]),
  textarea:enabled:not([tabindex="-1"]),
  select:enabled:not([tabindex="-1"]),
  [tabindex]:not(:disabled):not([tabindex="-1"]),
  [contenteditable]:not(:disabled):not([tabindex="-1"])
`;
